import React from 'react';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../../common/SafeIcon';

const { FaApple, FaGooglePlay } = FaIcons;

const APP_STORE_URL = "https://apps.apple.com/us/app/nisaa/id6772802488";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=uk.co.sussexendocrineclinic.nisaa";

const StoreStatusSection = () => {
  return (
    <section className="py-[70px] lg:py-[96px] bg-white border-y border-line">
      <div className="w-full max-w-[1120px] mx-auto px-4 grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-8 lg:gap-[34px] items-center">
        <div>
          <h2 className="text-[clamp(2.2rem,3vw,3rem)] mb-4">Available Now</h2>
          <p className="text-[1.05rem] lg:text-[1.18rem] text-[#4d4054]">
            Nisaa is officially live on major platforms. Download today to start your private health and spiritual journey.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <a 
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="p-8 rounded-3xl bg-aubergine text-white hover:bg-aubergine-light transition-all flex flex-col items-center text-center group"
          >
            <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <SafeIcon icon={FaApple} className="w-8 h-8" />
            </div>
            <h3 className="text-white text-xl mb-2">iOS Version</h3>
            <p className="text-white/60 text-sm">Download for iPhone and iPad on the App Store.</p>
          </a>

          <a 
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="p-8 rounded-3xl bg-teal text-white hover:bg-teal/90 transition-all flex flex-col items-center text-center group"
          >
            <div className="w-16 h-16 rounded-2xl bg-white/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <SafeIcon icon={FaGooglePlay} className="w-7 h-7" />
            </div>
            <h3 className="text-white text-xl mb-2">Android Version</h3>
            <p className="text-white/60 text-sm">Get it on Google Play for all Android devices.</p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default StoreStatusSection;